import { api } from './axios';
import { authService } from './auth';
import { geolocalizacaoService } from './geolocalizacao';

export interface AprovarAutorizacaoRequest {
  demandaAutorizacaoId: number;
  comentario?: string;
  ip: string;
  coordenadas: string;
  mac?: string;
}

export interface ReprovarAutorizacaoRequest {
  demandaAutorizacaoId: number;
  comentario?: string;
  ip: string;
  coordenadas: string;
  mac?: string;
}

class AutorizacaoService {
  /**
   * Aprova uma autorização de demanda
   */
  async aprovar(demandaAutorizacaoId: number, comentario?: string): Promise<{ message: string }> {
    await authService.ensureSanctumInitialized();
    
    // Captura localização do usuário
    const localizacao = await geolocalizacaoService.capturarLocalizacao();
    
    const payload = {
      comentario,
      ip: localizacao.ip || 'unknown',
      coordenadas: geolocalizacaoService.formatarCoordenadas(localizacao),
    };
    
    const response = await api.post<{ message: string }>(
      `/autorizacoes/${demandaAutorizacaoId}/aprovar`,
      payload
    );
    
    return response.data;
  }

  /**
   * Reprova uma autorização de demanda
   */
  async reprovar(demandaAutorizacaoId: number, comentario?: string): Promise<{ message: string }> {
    await authService.ensureSanctumInitialized();
    
    // Captura localização do usuário
    const localizacao = await geolocalizacaoService.capturarLocalizacao();
    
    const payload = {
      comentario,
      ip: localizacao.ip || 'unknown',
      coordenadas: geolocalizacaoService.formatarCoordenadas(localizacao),
    };
    
    const response = await api.post<{ message: string }>(
      `/autorizacoes/${demandaAutorizacaoId}/reprovar`,
      payload
    );
    
    return response.data;
  }
}

export const autorizacaoService = new AutorizacaoService();
